<template>
  <div class="boolean-toggle__wrapper">
    <div class="boolean-toggle">
      <div class="boolean-toggle__label-row">
        <span class="boolean-toggle__label">{{ label }}</span>
        <ShowHint v-if="hint" :hint="hint" />
        <HintInfo v-if="help" :texto="help" class="boolean-toggle__info-anchor" />
      </div>
      <label class="boolean-toggle__switch" :class="{ disabled: disabled }">
        <input
          type="checkbox"
          :checked="value"
          @change="$emit('input', $event.target.checked)"
          :disabled="disabled"
        />
        <span class="boolean-toggle__slider"></span>
        <span class="boolean-toggle__text">{{ value ? "Sim" : "Não" }}</span>
      </label>
    </div>
  </div>
</template>

<script>
import ShowHint from "@/components/ShowHint.vue";
import HintInfo from "@/components/form/HintInfo.vue";

export default {
  name: "BooleanToggle",
  components: { ShowHint, HintInfo },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      required: true,
    },
    hint: {
      type: String,
      default: "",
    },
    help: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.boolean-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 0;
  border-bottom: 1px solid #f0f0f0;
}

.boolean-toggle__label-row {
  display: flex;
  align-items: center;
  gap: 6px;
}

.boolean-toggle__label {
  font-size: 13px;
  color: #333;
}

.boolean-toggle__info-anchor {
  position: relative;
  display: inline-flex;
}

.boolean-toggle__switch {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  margin: 0;
  flex-shrink: 0;
}

.boolean-toggle__switch.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.boolean-toggle__switch input {
  display: none;
}

.boolean-toggle__slider {
  position: relative;
  width: 36px;
  height: 20px;
  background-color: #ccc;
  border-radius: 20px;
  transition: background-color 0.2s;
  flex-shrink: 0;
}

.boolean-toggle__slider::after {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 16px;
  height: 16px;
  background-color: #fff;
  border-radius: 50%;
  transition: transform 0.2s;
}

.boolean-toggle__switch input:checked + .boolean-toggle__slider {
  background-color: #3a3e81;
}

.boolean-toggle__switch input:checked + .boolean-toggle__slider::after {
  transform: translateX(16px);
}

.boolean-toggle__text {
  font-size: 12px;
  color: #777;
  min-width: 28px;
}

</style>
